import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { COLORS } from '@src/constants/design-tokens/colors';
import { useAccessibilityMeta, useDocumentLanguage } from '@src/hooks/useDocumentLanguage';
import { useFocusManagement } from '@src/hooks/useFocusManagement';
import { useInputTracking } from '@src/hooks/useInputTracking';
import { useKeyboardShortcuts } from '@src/hooks/useKeyboardShortcuts';
import { useReduxPersistence } from '@src/hooks/useReduxPersistence';
import { useRoutePersistence } from '@src/hooks/useRoutePersistence';
import { useScrollTracking } from '@src/hooks/useScrollTracking';
import useBootsrap from '@src/modules/react_hooks/bootstrap';
import { selectPrivateMode } from '@src/store/slices/private_mode';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useAppInitialization = () => {
  const theme = useTheme();
  const location = useLocation();
  const path = location.pathname;

  // 大デスクトップサイズから横並びレイアウト
  const isDesktopView = useMediaQuery(theme.breakpoints.up('lg'));
  // タブレットサイズ
  const isTabletView = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  const privateMode = useSelector(selectPrivateMode);

  // 起動シーケンス
  useBootsrap();

  // 永続化
  useReduxPersistence();
  useRoutePersistence(path, privateMode);

  // キーボードショートカット
  useKeyboardShortcuts();

  // フォーカス管理
  useFocusManagement({
    focusDelay: 200,
    scrollToTop: true,
    announcePageChange: true,
    focusTarget: 'main-content',
  });

  // 言語・メタデータ
  useDocumentLanguage();
  useAccessibilityMeta({
    themeColor: COLORS.primary.main,
    colorScheme: 'auto',
  });

  // イベントハンドリング
  const isScrolling = useScrollTracking();
  // デスクトップ表示時のみ入力監視を有効化（モバイル・タブレット時は不要）
  const isInputActive = useInputTracking(isDesktopView);

  return {
    isDesktopView,
    isTabletView,
    isScrolling,
    isInputActive,
    theme,
  };
};
